
import React from 'react';
import { TESTIMONIALS } from '../constants';

const Star: React.FC = () => (
  <svg className="w-4 h-4 text-yellow-400 fill-current" viewBox="0 0 24 24">
    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
  </svg>
);

const Testimonials: React.FC = () => {
  return (
    <section id="reviews" className="py-24 bg-white dark:bg-background-dark/30 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="flex justify-center gap-1 mb-6">
            {[1, 2, 3, 4, 5].map((s) => (
              <Star key={s} />
            ))}
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black mb-4 text-dark-gray dark:text-white">What Your Neighbors Say</h2>
          <p className="text-gray-500 dark:text-gray-400 text-sm sm:text-base">Over 500+ five-star reviews from satisfied Florida homeowners.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {TESTIMONIALS.map((t, idx) => (
            <div 
              key={idx} 
              className="bg-background-light dark:bg-gray-800/40 p-8 rounded-3xl relative border border-gray-100 dark:border-gray-700 flex flex-col justify-between hover:shadow-xl transition-all duration-300"
            >
              <div className="text-primary/10 text-6xl absolute top-4 left-4 font-black">"</div>
              <p className="italic text-gray-600 dark:text-gray-300 leading-relaxed mb-8 relative z-10 text-sm sm:text-base">
                {t.text}
              </p>
              <div className="flex items-center gap-4">
                <img 
                  src={t.imageUrl} 
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover border-2 border-primary/20"
                />
                <div>
                  <p className="text-sm font-bold text-dark-gray dark:text-white">{t.name}</p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">{t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
